import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { APP_URL } from "../config";
import {
  loginUser,
  signupUser,
  loginUserWithToken,
  addCreditEntry,
} from "../services/authService";
import { storage as localStorage } from "../utils/storage";

const useAuth = (
  setIsAuthenticated?: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [name, settName] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    const { data, error: loginError } = await loginUser(email, password);

    if (loginError) {
      setError(loginError);
    } else if (data && setIsAuthenticated) {
      setIsAuthenticated(true);
      await Promise.all([
        localStorage.set("img", data?.picture),
        localStorage.set("email", data.email),
        localStorage.set("name", data.name),
        localStorage.set("accessToken", data.accessToken),
        localStorage.set("id", data.uid),
        localStorage.set("refreshToken", data.refreshToken),
      ]);
      navigate("/home");
    }
  };

  const handleSignup = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!password || !email) {
      setError("Password and email are required");
      return;
    }

    const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    if (!password.match(passwordRegex)) {
      setError(
        "Password must have at least 8 characters, one uppercase letter, one lowercase letter, one number"
      );
      return;
    }

    if (password !== confirmPassword) {
      setError("password and confirm password do not match");
      return;
    }

    const { data, error: signupError } = await signupUser(
      email,
      password,
      name
    );

    if (signupError) {
      setError(signupError);
    } else if (data) {
      navigate("/");
    }
  };

  const handleLogout = async () => {
    await localStorage.clear();
    setIsLoggedIn(false);
    setShowModal(false);
    navigate("/");
  };

  const handleGoogleSignIn = () => {
    window.open(`${APP_URL}/authentication`, "_blank");
  };

  const handleContinue = () => {
    setShowModal(false);
    navigate("/home");
  };

  const signInWithFirebase = async (token: string) => {
    const { data, error: loginError } = await loginUserWithToken(token);

    if (loginError) {
      setError(loginError);
    } else if (data && setIsAuthenticated) {
      setIsAuthenticated(true);
      await addCreditEntry(data.uid, 30);
      await Promise.all([
        localStorage.set("img", data?.picture),
        localStorage.set("email", data.email),
        localStorage.set("name", data.name),
        localStorage.set("accessToken", data.accessToken),
        localStorage.set("id", data.uid),
        localStorage.set("refreshToken", data.refreshToken),
      ]);
      navigate("/home");
    }
  };


  return {
    email,
    password,
    error,
    isLoggedIn,
    showModal,
    name,
    confirmPassword,
    setConfirmPassword,
    settName,
    setPassword,
    setEmail,
    handleLogin,
    handleSignup,
    handleLogout,
    handleGoogleSignIn,
    setShowModal,
    handleContinue,
    signInWithFirebase,
  };
};

export default useAuth;
